import axios from "axios";

export const getDoctorAuditAPI  = async ()=>{
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/api/Audit/doctor-status`,
    );
    return response.data; 
  } catch (error: any) {
    console.error("Login failed", error);
  }
};



export const getDoctorAuditDetailsAPI  = async (doctId:number)=>{
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/api/Audit/auditdetails`,{params:{doctId}},
    );
    return response.data; 
  } catch (error: any) {
    console.error("Login failed", error);
  }
};